import React, { memo, useMemo } from "react";

// components
import { Text } from "@swiggy-private/dls-web-core/dist/components/Text";
import { SpriteIconWeb } from "@swiggy-private/dls-web-icons/dist/SpriteIconWeb";

// helpers
import { isEmpty } from "@swiggy-private/js-utils";
import { getlastWordSeparated } from "@super-ui/components/cart-upsell-nudge/helpers";

// styles
import { ChevronIcon, CtaContainer, PlanInfoCTATextWithIcon } from "./styles";

// constants
import { replaceAttributes } from "@super-ui/components/m2c-swiggy-one-halfcard/helpers";
import { CART_UPSELL_TEST_IDS, SUBTITLE_VARIANTS, VARIANTS } from "@super-ui/components/cart-upsell-nudge/constants";

interface PlanInfoCTAProps {
    text: string;
    handler: VoidFunction;
    changeSuperBtnRef?: React.RefObject<HTMLDivElement>;
    variant: VARIANTS;
    attributeValues: Record<string, string>;
}

const ChevronIconComponent = () => (
    <ChevronIcon>
        <SpriteIconWeb iconName="chevronRight12" fillColor="text_Low_Emphasis" />
    </ChevronIcon>
);

const PlanInfoCTA = ({ text, handler, changeSuperBtnRef, variant, attributeValues }: PlanInfoCTAProps) => {
    const variantsStyle = useMemo(() => SUBTITLE_VARIANTS[variant], [variant]);
    const { ref, ...variantsStyleWithoutRef } = variantsStyle;

    const updatedText = useMemo(() => {
        const replaceAttributesInText = replaceAttributes(text, attributeValues);
        const { firstSection, secondSection } = getlastWordSeparated(replaceAttributesInText);

        return (
            <>
                <Text as="span" {...variantsStyleWithoutRef}>
                    {firstSection}
                </Text>
                <PlanInfoCTATextWithIcon>
                    <Text as="span" {...variantsStyleWithoutRef}>
                        {secondSection}
                    </Text>
                    <ChevronIconComponent />
                </PlanInfoCTATextWithIcon>
            </>
        );
    }, [attributeValues, text, variantsStyleWithoutRef]);

    if (isEmpty(updatedText)) {
        return null;
    }

    return (
        <CtaContainer
            data-testid={CART_UPSELL_TEST_IDS.PLAN_INFO_CTA}
            role="button"
            onClick={handler}
            ref={changeSuperBtnRef}
            tabIndex={0}
        >
            {updatedText}
        </CtaContainer>
    );
};

export default memo(PlanInfoCTA);
